export default "__VITE_ASSET__Btom7IX9__"